import Vue from "vue";

const BASE_URL = "/presentes/";

class QuerySet extends Array {
  loading = false;
  current = null;
  total = null;
}

class Manager {
  many(url, model, params) {
    params = params || {};
    
    const req = Vue.http.get(url, { params });
    return req.then((resp) => {
      if (resp.status >= 400 && resp.status < 600) {
        throw resp;
      }
      return resp.json().then(json => {
        const page = parseInt(params.page);
        const qs = new QuerySet();
        json.results.forEach((e) => qs.push(new model(e)));
        qs.total = json.count;
        qs.loading = false;
        qs.current = Number.isNaN(page) ? 1 : page;
        return qs;
      });
    });
  }
  one(url, model, objId, params) {
    params = params || {};
    const toFetch = `${url}/${objId}/`;
    const req = Vue.http.get(toFetch, { params });
    return req.then((resp) => {
      if (resp.status >= 400 && resp.status < 600) {
        throw resp;
      }
      return resp.json().then((json) => {
        const instance = new model(json);
        return instance;
      });
    });
  }
}

class BaseModel {
  static baseUrl = BASE_URL;
  static objects = new Manager();
  constructor(data) {
    this.data = data;
  }
  static fetch(objId, params) {
    return this.objects.one(this.baseUrl, this, objId, params);
  }
  static fetchMany(params) {
    return this.objects.many(this.baseUrl, this, params);
  }
  get id() {
    return this.data.id;
  }
  get url() {
    return { name: "Detail", params: { id: this.id } };
  }
  get description() {
    return this.data.description || "";
  }
  get summary() {
    const texto = this.description || "";
    const maxLen = 150;
    const separator = " ";
    if (texto.length <= maxLen) return texto;
    return texto.substr(0, texto.lastIndexOf(separator, maxLen));
  }
  get fullName() {
    return this.data.full_name;
  }
  get picture() {
    const photos = this.data.photos;
    return photos.length != 0
      ? photos[0].url
      : "https://place-hold.it/320x256/7e9ed3/fff/7e9ed3?text=Sin%20imagen";
  }
}

export class Victim extends BaseModel {
  static baseUrl = BASE_URL + "api/victimas";
  constructor(data) {
    super(data);
  }
  get id() {
    return parseInt(this.data.id);
  }
  get url() {
    return { name: "VictimaDetail", params: { id: this.id } };
  }
  get nicknames() {
    return this.data.apodos.join(", ");
  }
  get personalData() {
    return this.data.extra;
  }
  get kidnapping() {
    const afsecuestro = this.data.secuestros;
    const len = afsecuestro.length;
    return afsecuestro[afsecuestro.length - 1];
  }
  get cce() {
    const places = this.data.cce;
    let names = "";
    const out = [];
    if (places.length == 0) {
      names = "";
    } else if (places.length == 1) {
      names = places[0].idcce.nombre;
    } else if (places.length > 1) {
      places.forEach((item, i) => {
        if (out.indexOf(item.idcce.idcce) == -1) {
          out.push(item.idcce.idcce);
          if (i != places.length - 1) {
            names += `${item.idcce.nombre}, `;
          } else {
            names += item.idcce.nombre;
          }
        }
      });
    }
    return names;
  }
}

export class Condenado extends BaseModel {
  static baseUrl = BASE_URL + "api/condenados";

  get id() {
    return parseInt(this.data.idrepre);
  }
  get url() {
    return { name: "CondenadoDetail", params: { id: this.id } };
  }
}
